import { Component } from "react";
import { NotFoundPic } from "../../../assets";
import { Helmet } from "react-helmet-async";
import { Button } from "../../components/button";
import { logout } from "../../../core/service";
class ProfileNotFound extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div className="not-found">
                <Helmet>
        <title> 404 |    یافت نشد</title>
      </Helmet>
                <div className="not-found-content">
                    <img src={NotFoundPic} className="content-img" alt="هامرز"/>

                    <span className="content-title">
                        اطلاعات شما در سامانه یافت نشد . 
                    </span>
                    <p className="content-desc">
                       لطفا با شعبه تماس بگیرید . 
                    </p>
                    <Button onClick={() => logout()} myStyle="bg-blue content-btn" title="بازگشت به صفحه ورود " />
                </div>
            </div>
        )
    }
}
export default ProfileNotFound;